import axios from 'axios'

export const fulfillmentApi = axios.create({
    baseURL: "/api/"
})